<template>
  <div id="wxshare"></div>
</template>

<script>
import wx from 'weixin-js-sdk';
import $ from 'jquery';

export default {
  name: 'WxShare',
  props: {
    shareTitle: String,
    shareDesc: String,
    shareImg: String,
    shareLink: String,
  },
  mounted () {
    this.sharethis()
  },
  methods: {
    sharethis(){
      const _this=this
      const server='/codes/jiandou/game.php/Home/Share/JDOU_shareWx/';
      const currenturl = window.location.href;
      const postData={ url:currenturl}
      $.ajax({
          type: "POST",
          url: server,
          data: postData,
          async: true,
          dataType: "json",
          success: function (result) {
              //分享功能 s
              wx.config({
                  debug: false,
                  appId: result.appId,
                  timestamp: result.timestamp,
                  nonceStr: result.nonceStr,
                  signature: result.signature,
                  jsApiList: [
                      'checkJsApi',
                      'onMenuShareTimeline',
                      'onMenuShareAppMessage',
                      'onMenuShareQQ',
                      'onMenuShareWeibo'
                  ]
              });
              _this.wechatReady();
          },
          error: function () {
              //window.alert("系统错误，请稍后再试");
          }
      });
    },
    wechatReady() {
      const _this=this
      wx.ready(function () {
        let appMessageShareData = {
            title:_this.shareTitle,
            desc:_this.shareDesc,
            link: _this.shareLink,
            imgUrl:_this.shareImg
        };
        wx.onMenuShareAppMessage(appMessageShareData);
        wx.onMenuShareTimeline(appMessageShareData);
        wx.onMenuShareQQ(appMessageShareData);
        wx.onMenuShareWeibo(appMessageShareData);
      })
      wx.error(function (res) {
          //alert(res.errMsg);
      });
    }
  }
}
</script>
